import ApiService from "@/common/api/api.service";

let apiBasePath = 'GrupoTurma'
const GrupoTurmaService = {
  async buscarGrupoTurmaPorCursoIdAnoLetivoOpcoes(cursoId, anoLetivoId) {
    const { data } = await ApiService.get(`GrupoTurma/opcoes`, {
      params: {
        cursoId: cursoId,
        anoLetivoId: anoLetivoId,
      }
    });
    return data.data.map(grupoTurma => ({ value: grupoTurma.id, text: grupoTurma.descricao }));
  },
  async buscarOpcoesGrupoTurma(tipoContrato) {
    const { data } = await ApiService.get(`GrupoTurma/opcoes-todos`, {
      params: {
        tipoContrato: tipoContrato,
      }
    });
    return data.data.map(grupoTurma => ({ value: grupoTurma.id, text: `${grupoTurma.cursoDescricao} - ${grupoTurma.descricao}` }));
  },
  async buscarPorCursoIdAnoLetivoId(cursoId, anoLetivoId) {
    let { data } = await ApiService.get(`grupoturma/obter-por-curso-id?cursoId=${cursoId}&anoLetivoId=${anoLetivoId}`);
    return data;
  },
  async buscarPorCursoId(cursoId) {
    let { data } = await ApiService.get(`grupoturma/obter-por-curso?cursoId=${cursoId}`);
    return data;
  },
  async buscarPorId(id) {
    let { data } = await ApiService.get(`${apiBasePath}/${id}`);
    return data;
  },
  async criar(form) {
    let { data } = await ApiService.post(`${apiBasePath}`, form);
    return data;
  },
  async editar(form) {
    let { data } = await ApiService.put(`${apiBasePath}`, form);
    return data;
  },
  async excluir(id) {
    return await ApiService.delete(`${apiBasePath}/${id}`);
  },
};

export default GrupoTurmaService;
